import script from "./Learn.vue?vue&type=script&setup=true&lang=js"
export * from "./Learn.vue?vue&type=script&setup=true&lang=js"

import "./Learn.vue?vue&type=style&index=0&id=48b8fcd4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b8fcd4"]])

export default __exports__